export const FILTER_DATE = 'date';
export const FILTER_COMPOSED_DATE_PICKER = 'composedDatePicker';
export const FILTER_RANGE_PICKER = 'rangePicker';
export const DATE_FILTER_ARR = [FILTER_DATE, FILTER_COMPOSED_DATE_PICKER, FILTER_RANGE_PICKER];
